import React from 'react'
import {Button, Col, Form, Input, Label, ListGroup, UncontrolledAlert, FormGroup, InputGroup} from 'reactstrap'
import Loader from 'react-loader-spinner'
import {provisioningHelpers, subscriptionHelpers, authenticationHelpers} from '../../../dataHelpers'
import {assignControllers, getAllControllers, getAllTeams, getControllers, lookupUserByEmail, assignControllerTeam, getTeam, planlist, getSubsControllers} from "../../../api"
import {ControllerAssignmentListItem, InfoAlert, ModelListTable,} from "../../ui"
import {pageHelpers} from '../'
import {AppError, Controller, UserConfirmationRequest, UserSelectionRequest} from "../../../models"
import AssignControllerIcon from 'react-icons/lib/fa/plus-square'
import '../../../stylesheets/Provision.css'

class AssignPage extends React.Component {
    constructor(props) {
        super(props)
        pageHelpers.setupPropsForPage(props, this)
        const {token, isSupport} = props

        let teamID = this.urlParams.team_id
        if (!teamID && this.user) {
            teamID = this.user.activeTeam
        }

        let selectedControllerIDs = this.queryParams.controllers
        console.log("selectedControllerIDs are")
        console.log(selectedControllerIDs)

        if (selectedControllerIDs) {
            selectedControllerIDs = selectedControllerIDs.split(",")
            selectedControllerIDs = selectedControllerIDs.filter(c => c.length).map(c => parseInt(c))
        } else {
            selectedControllerIDs = []
        }
        let selectedControllers = selectedControllerIDs
        console.log("selectedControllers are")
        console.log(selectedControllers)

        this.state = {
            token,
            isSupport,
            teamID,
            selectSubscriptionID: null,
            teams: [],
            errors: [],
            loading: false,
            assignedControllers: [],
            availableControllers: [],
            selectedControllers,
            availablePlans: [],
            userConfirmationRequests: [],
            userSelectionRequests: [],
            activeInfoAlert: 0,
            pastTeam:''
        }

        this.submitDealerForm = this.submitDealerForm.bind(this)
        this.submitSupportForm = this.submitSupportForm.bind(this)
        this.handleWebSocketResponse = this.handleWebSocketResponse.bind(this)
        this.fetchAssignedControllersState = this.fetchAssignedControllersState.bind(this)
        this.fetchAvailableControllers = this.fetchAvailableControllers.bind(this)
        this.dismissUserConfirmationRequest = this.dismissUserConfirmationRequest.bind(this)
        this.dismissUserSelectionRequest = this.dismissUserSelectionRequest.bind(this)
        this.handleSelectedControllersChange = this.handleSelectedControllersChange.bind(this)
        this.fetchSubsPlanList = this.fetchSubsPlanList.bind(this)

        const dealerInfoAlerts = [
            {
                body: "Assigning controllers moves them from your inventory to a customer's inventory. To start, select the controllers you want to assign below. You can sort the list below by clicking \"Serial Number\" or \"Name\". You can filter the list using the search box.",
                alertKey: "ASSIGN_DEALER_1",
            },
            {
                body: "Next, enter the email address of the customer you would like to assign to.",
                alertKey: "ASSIGN_DEALER_2"
            },
        ]

        const supportInfoAlerts = [
            {
                body: "Assigning controllers moves them from being unassigned to a customer or dealer's inventory. To start, select the controllers you want to assign below. You can sort the list below by clicking \"Serial Number\" or \"Name\". You can filter the list using the search box.",
                alertKey: "ASSIGN_SUPPORT_1",
            },
            {
                body: "Next, select the team you would like to assign to.",
                alertKey: "ASSIGN_SUPPORT_2"
            },
        ]

        this.infoAlerts = (isSupport ? supportInfoAlerts : dealerInfoAlerts)
    }

    async componentWillReceiveProps(nextProps) {
        pageHelpers.setupPropsForPage(nextProps, this)
        const {token, isSupport} = nextProps

        let teamID = this.urlParams.team_id
        if (!teamID && this.user) {
            teamID = this.user.activeTeam
        }

        let selectedControllerIDs = this.queryParams.controllers
        console.log("selectedControllerIDs are")
        console.log(selectedControllerIDs)
        if (selectedControllerIDs) {
            selectedControllerIDs = selectedControllerIDs.split(",")
            selectedControllerIDs = selectedControllerIDs.filter(c => c.length).map(c => parseInt(c))
            this.setState({selectedControllers:selectedControllerIDs})
        }
        console.log("selectedControllers are")
        console.log(selectedControllerIDs)

        await this.setState({token, isSupport, teamID})

        if (token) {
            let {availableControllers} = this.state
            if (!availableControllers || !availableControllers.length) {
                this.setState({loading: true})
            }
            await this.fetchAvailableControllers()
            await this.fetchAssignedControllersState()
            if (isSupport) {
                await this.fetchTeams()
            }
            this.setState({loading: false})
        }
    }

    async componentDidMount() {
        let {token, isSupport} = this.state
        if (token) {
            this.setState({loading: true})
            await this.fetchAvailableControllers()
            await this.fetchAssignedControllersState()
            await this.fetchSubsPlanList()
            if (isSupport) {
                await this.fetchTeams()
            }
            this.setState({loading: false})
        }
    }


    dismissUserConfirmationRequest() {
        this.setState({userConfirmationRequests: [], loading: false})
    }

    dismissUserSelectionRequest() {
        this.setState({userSelectionRequests: [], loading: false})
    }

    async fetchAvailableControllers() {
        try {
            let {teamID, token, isSupport} = this.state
            let availableControllers
            if (isSupport) {
                let response = await getAllControllers(token, false, true, false, true, false, true, 1, 10000, '')
                availableControllers = response.results
            } else {
                let response = await getControllers(token, teamID, true, false, true, 1, 10000)
                availableControllers = response.results

                let currentTeam = authenticationHelpers.getCurrentTeam()
                let teamResponse = await getTeam(this.token, currentTeam)
                this.setState({ availableTeam: teamResponse.name, pastTeam: teamResponse.id})

                let planResponse = await planlist(token)
                this.setState({ availablePlans: planResponse })

                let subResponse = await getSubsControllers(token, currentTeam)
                this.setState({ subsControllers: subResponse })

                for (let x=0; x<availableControllers.length; x++) {
                    let con = availableControllers[x]
                    if (subResponse && subResponse.length) {
                        for (let y=0; y<subResponse.length; y++) {
                            let subcon = subResponse[y];
                            if (subcon.serialNumber == con.serialNumber) {
                                con.subscriptionPlan = subcon.subscriptionPlan
                            }
                        }
                        availableControllers[x] = con
                    }
                }
            }

            this.setState({availableControllers})
        } catch (e) {
            console.log(e)
        }
    }

    async fetchAssignedControllersState() {
        let {assignedControllers, token} = this.state
        for (let i = 0; i < assignedControllers.length; i++) {
            let controller = assignedControllers[i]
            let searchResponse = await provisioningHelpers.searchSerialNumber(token, controller.serialNumber, false)
            if (!searchResponse.error && searchResponse.controller) {
                assignedControllers[i] = searchResponse.controller
            }
            
        }
        this.setState({assignedControllers})
    }

    async fetchSubsPlanList(){
        let {token} = this.state
        let planlistResponse = await subscriptionHelpers.getActivePlanList(token)
        if (!planlistResponse.error) {
            this.setState({planData:planlistResponse})
            planlistResponse.map((subsList) => (
                (subsList.is_seasoned === false ? this.setState({selectSubscriptionID:subsList.id}):null)
            ))
        } else {
            this.setState({errors:[planlistResponse.error]})
        }
    }

    async fetchTeams() {
        try {
            let {token} = this.state
            let {results, count} = await getAllTeams(token, true, true, true, false, 1, 10000)
            let teams = results.sort((a, b) =>
                ((a.name || '').toLowerCase() < (b.name || '').toLowerCase()) ? -1 : ((a.name || '').toLowerCase() > (b.name || '').toLowerCase()) ? 1 : 0
            )
            this.setState({teams: results})
        } catch (error) {
            console.log(error)
        }
    }

    async submitDealerForm(e) {
        e.preventDefault()
        this.setState({loading: true})
        let email = e.target['email'].value
        let {selectedControllers, availableControllers, assignedControllers, token, availablePlans, selectSubscriptionID, planData, pastTeam } = this.state

        if (!selectedControllers || !selectedControllers.length) {
            let appError = new AppError("No Controller Selected", `Please select one or more controllers to assign.`)
            await this.setState({errors: [appError], loading: false})
            return
        } else if (!email || !email.length) {
            let appError = new AppError("No Email Specified", `Please enter a user's email address to assign controllers to.`)
            await this.setState({errors: [appError], loading: false})
            return
        }

        let firstController = availableControllers.filter(c => c.id === selectedControllers[0])[0]
        let controllerMessage = (selectedControllers.length > 1 ?
            `these <strong>${selectedControllers.length}</strong> controllers` :
            `<strong>${firstController.userIdentifiableName}</strong>`)

        try {
            let user = await lookupUserByEmail(token, email)

            if (user.teams && user.teams.length > 1) {
                let select = async (selectedTeam) => {
                    this.setState({loading: true})

                    let cons = availableControllers.filter(c => selectedControllers.indexOf(c.id) > -1)
                    let serials = cons.map(c => c.id)
                    let subsPlanID = cons.map(c => c.subscriptionPlan)
                    console.log("available plans:")
                    console.log(availablePlans)
                    console.log("subs plan id:")
                    console.log(subsPlanID)
                    if (subsPlanID && subsPlanID.length) {
                        subsPlanID = subsPlanID[0]
                    }
                    console.log("corrected subs plan id:")
                    console.log(subsPlanID)

                    let isSeasonedData = availablePlans.filter((t) => t.id == subsPlanID)
                    console.log("seasonedData:")
                    console.log(isSeasonedData)
                    let is_seasonedVal = false
                    if(isSeasonedData[0]){
                        let is_seasonedVal = isSeasonedData[0].is_seasoned
                    }

                    //let is_seasonedVal = isSeasonedData[0].is_seasoned

                    this.setState({ loading: true })
                    //let controllers = await assignControllers(this.token, serials, selectedTeam.id, true) // client API
                    let controllers = await assignControllerTeam(token, serials, selectedTeam.id, subsPlanID, is_seasonedVal, pastTeam)

                    assignedControllers = assignedControllers.concat(controllers)
                    this.setState({
                        assignedControllers,
                        activeInfoAlert: 0,
                        selectedControllers: [],
                        userSelectionRequests: [],
                        loading: false
                    })
                    for (let i = 0; i < this.state.assignedControllers.length; i++) {
                        let controller = this.state.assignedControllers[i]
                        
                        let getTeamName = await getTeam(token, controller.team)
                        controller.team = {'id': getTeamName.id, 'name': getTeamName.name}
                    }
                    await this.fetchAvailableControllers()
                    await this.fetchAssignedControllersState()
                    await this.fetchSubsPlanList()
                }

                let request = new UserSelectionRequest('Assign Controller',
                    `<strong>${user.firstName} ${user.lastName}</strong> (${email}) ` +
                    " is a member of multiple teams. <br/> " +
                    `Which team do you want to assign ${controllerMessage} to? <br/>`,
                    select,
                    this.dismissUserSelectionRequest,
                    user.teams)

                this.setState({userSelectionRequests: [request]})
            } else if (user.teams && user.teams.length === 1) {
                let team = user.teams[0]
                let confirm = async () => {
                    let cons = availableControllers.filter(c => selectedControllers.indexOf(c.id) > -1)
                    let serials = cons.map(c => c.id)
                    let subsPlanID = cons.map(c => c.subscriptionPlan)
                    if (subsPlanID && subsPlanID.length) {
                        subsPlanID = subsPlanID[0]
                    }

                    let isSeasonedData = availablePlans.filter((t) => t.id == subsPlanID)
                    console.log("isSEASONEDDATA IS")
                    console.log(isSeasonedData)
                    console.log("subsPlanId")
                    console.log(subsPlanID)
                    let is_seasonedVal = isSeasonedData[0].is_seasoned

                    this.setState({loading: true})
                    //let controllers = await assignControllers(this.token, serials, selectedTeam.id, true) // client API
                    let controllers = await assignControllerTeam(token, serials, team.id, subsPlanID, is_seasonedVal, pastTeam)

                    assignedControllers = assignedControllers.concat(controllers)
                    
                    this.setState({
                        assignedControllers,
                        activeInfoAlert: 0,
                        selectedControllers: [],
                        userSelectionRequests: [],
                        loading: false
                    })

                    for (let i = 0; i < this.state.assignedControllers.length; i++) {
                        let controller = this.state.assignedControllers[i]
                        
                        let getTeamName = await getTeam(token, controller.team)
                        controller.team = {'id': getTeamName.id, 'name': getTeamName.name}
                    }

                    await this.fetchAvailableControllers()
                    await this.fetchAssignedControllersState()
                    await this.fetchSubsPlanList()
                    await this.dismissUserConfirmationRequest()
                    
                }

                let request = new UserConfirmationRequest('Assign Controller',
                    `Are you sure you want to assign ${controllerMessage} to ${team.name}?`,
                    confirm,
                    this.dismissUserConfirmationRequest)
                await this.setState({userConfirmationRequests: [request]})

            } else {
                let appError = new AppError("Error", `${user.firstName} ${user.lastName} (${email}) is a user but is not a member of any team.`)
                await this.setState({errors: [appError]})
            }
            

            await this.setState({loading: false})
        } catch (error) {
            console.log(error)
            let confirm = async () => {
                let serials = selectedControllers.map(sc => availableControllers.filter(ac => ac.id === sc)[0].serialNumber)
                this.history.push(`/management/teams/provision/customer?email=${email}&controllers=${serials.join(',')}`)
                this.setState({userConfirmationRequests: []})
            }

            let request = new UserConfirmationRequest('Unable to Find User',
                `<strong>${email}</strong> is not associated with any user.<br/> ` +
                `Would you like to create a new team and user for <strong>${email}</strong>?`,
                confirm,
                this.dismissUserConfirmationRequest)
            await this.setState({userConfirmationRequests: [request]})
        }
    }

    async submitSupportForm(e) {
        e.preventDefault()
        let {selectedControllers, token, selectSubscriptionID, planData} = this.state
        let selectedTeamID = e.target['selectedTeamID'].value

        if (!selectedControllers || !selectedControllers.length) {
            let appError = new AppError("No Controllers Selected",
                "Please select controllers to assign.")
            await this.setState({errors: [appError], loading: false})
            return
        } else if (!selectedTeamID || !selectedTeamID.length || selectedTeamID === "No Team") {
            let appError = new AppError("No Team Selected",
                "Please select a team to assign controllers to.")
            await this.setState({errors: [appError], loading: false})
            return
        }

        this.setState({loading: true})
        try {
            let isSeasonedData = planData.filter((t) => t.id == selectSubscriptionID)
            let is_seasonedVal = isSeasonedData[0].is_seasoned
            let results = await assignControllerTeam(token, selectedControllers, selectedTeamID, selectSubscriptionID, is_seasonedVal, null)
            
            await this.setState({
                assignedControllers: results,
                selectedControllers: [],
            })

	    await this.fetchAvailableControllers()
	    await this.fetchAssignedControllersState()
        await this.fetchSubsPlanList()
        
        for (let i = 0; i < this.state.assignedControllers.length; i++) {
            let controller = this.state.assignedControllers[i]
            
            let getTeamName = await getTeam(token, controller.team)
            controller.team = {'id': getTeamName.id, 'name': getTeamName.name}
        }

        } catch (error) {
            console.log(error)
            let appError = new AppError("Failed to Assign Controller to Team",
                "There was an issue assigning the controller. " +
                "Please verify the serial number and try again")
            await this.setState({errors: [appError]})
        }

        
        this.setState({loading: false, })
    }

    handleSelectedControllersChange(selectedControllers) {
        if (selectedControllers && selectedControllers.length) {
            this.setState({activeInfoAlert: 1})
        } else {
            this.setState({activeInfoAlert: 0})
        }
        this.setState({selectedControllers})
    }

    handleWebSocketResponse(data) {
        let {assignedControllers} = this.state
        let result = JSON.parse(data)
        let updatedController = Controller.fromAPIObject(result)
        let oldControllers = assignedControllers.filter(c => c.id === updatedController.id)
        let filteredControllers = assignedControllers.filter((controller) => controller.id !== updatedController.id)
        if (filteredControllers.length < assignedControllers.length) {
            let assignedControllers = filteredControllers
            if (oldControllers && oldControllers.length > 0) {
                let oldController = oldControllers[0]
                updatedController.team = oldController.team
                assignedControllers.push(updatedController)
            } else {
                assignedControllers.push(updatedController)
            }
            this.setState({assignedControllers})
        }
    }

    render() {
        let {
            assignedControllers, errors, loading, selectedControllers, activeInfoAlert, teams,
            availableControllers, userConfirmationRequests, userSelectionRequests, token, isSupport, planData,
        } = this.state

        return <div className="row col-12 p-0 m-0 justify-content-center">
            <div className="row col-12 p-0 m-0 justify-content-center">
                {this.user && this.user.isSupport && !isSupport ?
                    <UncontrolledAlert color="warning">
                        This is the Dealer view of the Assign Controllers Page. Support users should only use this for demonstration.
                    </UncontrolledAlert> :
                    null}
                <h1 className="col-12 mb-4 d-block d-sm-none light-sf-orange font-weight-bold"><AssignControllerIcon
                    className="light-sf-blue mr-2"/>Assign Controllers To Team</h1>
                <h1 className="col-12 mb-4 d-none d-sm-block light-sf-orange font-weight-bold"><AssignControllerIcon
                    className="light-sf-blue mr-2"/>Assign Marksman Controllers To a Team</h1>
                {(loading ?
                        <div className="col-12 align-content-center mt-5 mb-3">
                            <Loader type="TailSpin" color="orange" width={60} height={60}/>
                        </div> :
                        <Col xs={12} className="no-gutters">
                            <Col xs={12} lg={10} className="no-gutters offset-0 offset-lg-1 text-left">
                                <InfoAlert header={"Assigning Controllers"}
                                           body={this.infoAlerts[activeInfoAlert].body}
                                           alertKey={this.infoAlerts[activeInfoAlert].alertKey}/>
                                <label>Controllers{selectedControllers && selectedControllers.length ? <span
                                    className="semi-opaque">&ensp;&mdash;&ensp;{selectedControllers.length} Selected</span> : null}</label>
                                <ModelListTable models={availableControllers}
                                                fields={["serialNumber", "name"]}
                                                searchFields={["serialNumber", "name"]}
                                                boldFields={["serialNumber"]}
                                                hideableFields={["name"]}
                                                selectable={true}
                                                actionName="Assign"
                                                selected={selectedControllers}
                                                onSelectedChange={this.handleSelectedControllersChange}
                                                className="mb-4"/>
                                {isSupport ?
                                    <FormGroup>
                                        <div className="text-left">
                                            <Label>Subscription Plan</Label>
                                        </div>
                                        <InputGroup>
                                            <Input type="select" name="selectSubscriptionID"
                                                   onChange={(evt) => this.setState({selectSubscriptionID: evt.target.value})}>
                                                {planData ? planData.map((subsList) => (
                                                    <option key={`${subsList.id}`} value={subsList.id} selected={subsList.is_seasoned === false}>
                                                        &ensp;{subsList.name}
                                                    </option>
                                                )): 'No Plan'}
                                            </Input>
                                        </InputGroup>
                                    </FormGroup>: null}
                                {isSupport ?
                                    <Form className="m-0 p-0" onSubmit={this.submitSupportForm}>
                                        <div className="text-center mt-4">
                                            <div className="text-left">
                                                <Label>Team</Label>
                                            </div>
                                            <Input type="select" name="selectedTeamID"
                                                   className="col-12 col-md-8 d-inline-block">
                                                <option value={null}>No Team</option>
                                                {teams.map((team, idx) => (
                                                    <option key={`team-option-${team.id}-${idx}`}
                                                            value={team.id}>
                                                        {team.name} &mdash; {team.controllers.length} Controllers
                                                    </option>
                                                ))}
                                            </Input>
                                            <Button
                                                className="mt-3 mt-md-0 offset-0 offset-sm-1 col-12 col-sm-5 col-md-3">
                                                Assign
                                            </Button>
                                        </div>
                                    </Form> :
                                    <Form className="m-0 p-0" onSubmit={this.submitDealerForm}>
                                        <div className="text-center mt-4">
                                            <div className="text-left">
                                                <Label>Customer Email</Label>
                                            </div>
                                            <Input type="email"
                                                   name="email"
                                                   className="col-12 col-md-8 d-inline-block"/>
                                            <Button
                                                className="mt-3 mt-md-0 offset-0 offset-sm-1 col-12 col-sm-5 col-md-3">
                                                Assign to Customer
                                            </Button>
                                        </div>
                                    </Form>}
                            </Col>
                        </Col>
                )}

                {pageHelpers.renderErrorModalsForPage(errors, this)}
                {pageHelpers.renderUserConfirmationModals(userConfirmationRequests)}
                {pageHelpers.renderUserSelectionModals(userSelectionRequests)}
            </div>
            {(loading ? null :
            assignedControllers.length > 0 && token ?
                <div id="provisioned-controllers" className="row mt-4 justify-content-center align-items-center">
                    <hr/>
                    <br/>
                    <h3 className="col-12 mt-3">Assigned Controllers</h3>
                    <ListGroup>
                        {assignedControllers.map((controller, idx) => (
                            <ControllerAssignmentListItem controller={controller}
                                                          key={idx}
                                                          token={token}
                                                          handleWebSocketResponse={this.handleWebSocketResponse}/>
                        ))}
                    </ListGroup>
                </div>
                : null
                )}
        </div>
    }
}

export default AssignPage



// WEBPACK FOOTER //
// ./src/components/pages/controllers/AssignPage.js